export default function worldPayActions(payment) {
    const paymentToken = payment.token;
    const billingInformation = payment.billingContact;
    const shippingInformation = payment.shippingContact;

    if (typeof eProtect !== 'function') {
        alert(
            'We are experiencing technical difficulties. Please try again later or visit our help center to contact us.'
        );
        return false;
    }
    var applepay = {
        data: paymentToken.paymentData.data,
        signature: paymentToken.paymentData.signature,
        version: paymentToken.paymentData.version,
        header: {
            ephemeralPublicKey: paymentToken.paymentData.header.ephemeralPublicKey,
            publicKeyHash: paymentToken.paymentData.header.publicKeyHash,
            transactionId: paymentToken.paymentData.header.transactionId
        }
    };

    var eProtectRequest = {
        paypageId: document.getElementById('PayPageId').value,
        reportGroup: document.getElementById('PayPageReportGroup').value,
        orderId: document.getElementById('PayPageOrderId').value,
        id: document.getElementById('PayPageMerchantTransmissionId').value,
        checkoutIdMode: true,
        applepay: applepay,
        url: document.getElementById('PayPageUrl').value
    };

    return new Promise(resolve => {
        // eslint-disable-next-line new-cap
        new window.eProtect().sendToEprotect(
            eProtectRequest,
            response => {
                onErrorAfterEprotect(response);
                resolve(false);
            },
            response => {
                const walletItem = {
                    token: JSON.stringify(response),
                    emailAddress: shippingInformation?.emailAddress,
                    firstName: billingInformation?.givenName,
                    lastName: billingInformation?.familyName,
                    phone: shippingInformation?.phoneNumber,
                    billingAddress: {
                        address1: billingInformation?.addressLines[0],
                        address2: billingInformation?.addressLines[1],
                        city: billingInformation?.locality,
                        state: billingInformation?.administrativeArea,
                        postalCode: billingInformation?.postalCode,
                        countryCode: billingInformation?.countryCode
                    }
                };
                resolve(walletItem);
            },
            timeoutOnEprotect,
            15000
        );
    });

    function timeoutOnEprotect() {
        alert('We are experiencing technical difficulties. Please try again later or call 555-555-1212 (timeout)');
        return false;
    }

    function onErrorAfterEprotect(response) {
        const errorMessages = {
            871: 'Invalid card number. Check and retry. (Not Mod10)',
            872: 'Invalid card number. Check and retry. (Too short)',
            873: 'Invalid card number. Check and retry. (Too long)',
            874: 'Invalid card number. Check and retry. (Not a number)',
            875: 'We are experiencing technical difficulties. Please try again later or call 555-555-1212',
            876: 'Invalid card number. Check and retry. (Failure from Server)',
            881: 'Invalid card validation code. Check and retry. (Not a number)',
            882: 'Invalid card validation code. Check and retry. (Too short)',
            883: 'Invalid card validation code. Check and retry. (Too long)',
            889: 'We are experiencing technical difficulties. Please try again later or call 555-555-1212'
        };

        if (errorMessages[response.response]) {
            alert(errorMessages[response.response]);
        }
        return false;
    }
}
